import { mdiCheck, mdiChevronLeft, mdiChevronRight, mdiMenuDown } from '@mdi/js';
import Icon from '@mdi/react';
import moment from 'moment-jalaali';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import DatePicker from 'react-datepicker2';
import { useDispatch, useSelector } from 'react-redux';
import ListS from '../../UI/ListS/ListS';
import useHttp from '../../../hooks/http';
import { showError } from '../../../store';
import Listview2 from './Listview2';
import './Listview.scss';

const WeatherList = (props) => {
  const [Conclude, setConclude] = useState();
  const [Type, setType] = useState();
  const [Stations, setStations] = useState();
  const [Range, setRange] = useState(1);
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const token = useSelector((state) => state.auth.Token);
  const dispatch = useDispatch();
  const setMessage = useCallback(
    (mess) => {
      dispatch(showError(mess));
    },
    [dispatch]
  );

  const ItemPerPage = useRef(10);
  const [dates, setDates] = useState(() => {
    const the = [];
    for (let i = 0; i < ItemPerPage.current; i++) {
      the.push([moment(), moment()]);
    }
    return the;
  });

  const { id, item, types, urlF, urlS, types2, list2 } = props;

  useEffect(() => {
    sendRequest(urlF, 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token, urlF]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      setStations(data);

      clear();
    }
  }, [error, isLoading, data, clear, setMessage]);

  useEffect(() => {
    const ds = [];
    for (let i = 0; i < ItemPerPage.current; i++) {
      ds.push([moment(), moment()]);
    }
    setDates(ds);
  }, [Range, setDates]);

  const handleList = useCallback(
    (e, i) => {
      if (types && !Type) {
        setMessage({ message: 'نوع داده را انتخاب کنید', type: 'error' });
      } else {
        const start = moment(dates[i][0]).format('YYYY-MM-DD');
        const end = moment(dates[i][1]).format('YYYY-MM-DD');

        if (start >= end) {
          setMessage({ message: 'تاریخ را بدرستی انتخاب کنید', type: 'error' });
        } else {
          let url = `${urlS}?start_date=${start}&end_date=${end}&${id}=${e.id}`;
          if (Type) {
            url += `&${item}=${Type}`;
          }
          console.log(url);
          setConclude({ url2: url, type: Type, types2: types2, list2: list2 });
        }
      }
    },
    [setConclude, dates, Type, setMessage, types, types2, id, item, list2, urlS]
  );

  const theStations = useMemo(() => {
    if (Stations) {
      const array = [];

      for (let i = (Range - 1) * ItemPerPage.current; i < Range * ItemPerPage.current && i < Stations.length; i++) {
        array.push(Stations[i]);
      }

      const setDS = (e, i, a) => {
        setDates((pre) => {
          const the = [...pre];
          const changed = [...pre[i]];
          changed[a] = e;
          the.splice(i, 1, changed);

          return the;
        });
      };

      return array.map((e, i) => (
        <ul key={e.code}>
          <li>{e.name}</li>
          <li>{e.code}</li>
          {types && <li></li>}
          <li className='DatePickerCustom'>
            <DatePicker
              showTodayButton={false}
              isGregorian={false}
              timePicker={false}
              persianDigits={false}
              value={dates[i][0]}
              onChange={(e) => setDS(e, i, 0)}
            />
          </li>
          <li className='DatePickerCustom'>
            <DatePicker
              showTodayButton={false}
              isGregorian={false}
              timePicker={false}
              persianDigits={false}
              value={dates[i][1]}
              onChange={(e) => setDS(e, i, 1)}
            />
          </li>
          <li>
            <span
              onClick={() => handleList(e, i)}
              style={{
                fontSize: '13px',
                border: '2px solid #00a18e',
                borderRadius: '25px',
                padding: '0 10px',
                cursor: 'pointer',
              }}
            >
              دریافت لیست
            </span>
          </li>
        </ul>
      ));
    }
  }, [Range, Stations, dates, setDates, handleList, types]);

  const PageRange = useMemo(() => {
    return (
      <div className='pageRange'>
        <div>صفحه قبل</div>
        <div>
          <div>
            <Icon size={1} path={mdiChevronLeft} onClick={() => setRange((pre) => (pre === 1 ? pre : pre - 1))} />
          </div>
          <div>{Range}</div>
          <div>
            <Icon
              size={1}
              path={mdiChevronRight}
              onClick={() => setRange((pre) => (Stations[Range * ItemPerPage.current] ? pre + 1 : pre))}
            />
          </div>
        </div>
        <div>صفحه بعد</div>
      </div>
    );
  }, [Range, setRange, Stations]);

  return Conclude ? (
    <Listview2 {...Conclude} />
  ) : (
    <ListS>
      <ul>
        <li>نام ایستگاه</li>
        <li>کد ایستگاه</li>
        {types && (
          <li className='hoverList'>
            <Icon path={mdiMenuDown} />
            نوع داده
            <ul>
              {types.map((e) => (
                <li onClick={() => setType(e.en)} key={e.en}>
                  <Icon
                    path={mdiCheck}
                    color='blue'
                    size={1}
                    style={{ visibility: Type === e.en ? 'visible' : 'hidden' }}
                  />
                  {e.fa}
                </li>
              ))}
            </ul>
          </li>
        )}
        <li>تاریخ شروع</li>
        <li>تاریخ پایان</li>
        <li>لیست اطلاعات</li>
      </ul>
      {theStations}
      {PageRange}
    </ListS>
  );
};

export default WeatherList;
